import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { WelletContext } from '../../../context/WelletContext';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import Button from '../../../components/Common/Button/Button';
import useForm from '../../../helpers/useForm';
import { Spinner } from '../../../components/Common/Spinner/Spinner';
import InputFormBorder from '../../../components/Common/InputFormBorder/InputFormBorder';
import ErrorBox from '../../../components/Common/ErrorBox/ErrorBox';
import FixedButton from '../../../components/Common/FixedButton/FixedButton';

const LoginUserScreenEmail = () => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const [errorUser, setErrorUser] = useState(undefined);
  const [verifyingUser, setVerifyingUser] = useState(false);
  const app = useSelector((state) => state.app);
  const tenantId = useSelector((state) => state.app.tenantId);

  function validate(values) {
    let errors = {};

    if (!values.email) {
      errors.email = t('emailError.EMPTY_EMAIL');
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = t('emailError.INVALID_EMAIL');
    }

    return errors;
  }

  const sendForm = async () => {
    setVerifyingUser(true)
    setErrorUser(undefined)
    try {
      const result = await welletContext.apis.tickets.post(`users/Available`, {
        email: values.email,
        tenantId: tenantId,
      })
      if (!result.data.isAvailable) {
        if (result.data.availableMessage === "USER_NOT_FOUND") {
          setErrorUser(t("login.userNotFound"))
        } else {
          setErrorUser(t("callApiError"))
        }
      } else {
        history.push({
          pathname: "/login-method-selector",
          search: "?email=" + values.email,
        })
      }
    } catch (error) {
      console.error(error)

      if (error.response?.data === "USER_NOT_FOUND") {
        setErrorUser(t("login.userNotFound"))
      } else {
        setErrorUser(t("callApiError"))
      }
    } finally {
      setVerifyingUser(false)
    }
  }


  const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  const history = useHistory();

  const onChangeEmail = (e) => {
    handleChange(e);
    setErrorUser(null);
  };

  const inputEmail = () => (
    <InputFormBorder
      name={'email'}
      type={'email'}
      label='E-mail'
      value={values.email}
      placeholder={t('login.email')}
      error={errors.email}
      onChange={onChangeEmail}
      forceLowecase={true}
    />

  );

  return (
    <>
      <Header title={''} hasBackground={true} />
      <ContentApp background={true}>
        <div className=''>
          <form onSubmit={handleSubmit}>
            <div className='font-medium bold' style={{ color: '#fff' }}>
              {t('login.title')}
            </div>
            <div className='text-secondary font-tiny mt-1'>{t('login.subtitle')}</div>

            <div className='mt-4 pt-2'>{inputEmail()}</div>

            <FixedButton>
              {errorUser && (
                <div className='mb-3'>
                  <ErrorBox title={errorUser} />
                </div>
              )}
              <Button
                size={'large'}
                text={
                  verifyingUser ? (
                    <div className='d-flex justify-content-center'>
                      <Spinner size={25} color='#000' />
                    </div>
                  ) : (
                    t('continue')
                  )
                }
                className={`${verifyingUser ? 'loading' : ''} btn-primary`}
                hasBorder={true}
                icon={verifyingUser ? false : true}
                iconColor='#000'
                typeIcon='arrow'
              />
            </FixedButton>
          </form>
        </div>
      </ContentApp>
    </>
  );
};

export default LoginUserScreenEmail;
